import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'removeSpecialChars' })
export class RemoveSpecialChars implements PipeTransform {
    /**
     * Transform
     * Remove special character from string except numbers and letters
     *
     * @param {string} value
     * @returns {string}
     */
    transform(value: string): string {
        return value.replace(/[^a-zA-Z0-9]/g, ' ');
    }
}
